/* tslint:disable */
/* eslint-disable */
import { GlobalEnumsAceTypprojektbericht as AceXFoundPortalCoreEntitiesGlobalEnumsAceTypprojektbericht } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-typprojektbericht';
import { AceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode as AceXFoundPortalCoreEntitiesAceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode } from '../../../../../../ace/xFound/Portal/Core/Entities/ace-projektbericht-ace-projektbericht-enums-ace-projektbericht-statuscode';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IProjektberichtDisplayModel {
  datumBis?: null | string;
  datumEingang?: null | string;
  datumFaelligkeit?: null | string;
  datumVon?: null | string;
  projectId?: string;
  projektberichtId?: string;
  status?: AceXFoundPortalCoreEntitiesAceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode;
  typ?: AceXFoundPortalCoreEntitiesGlobalEnumsAceTypprojektbericht;
}
export class ProjektberichtDisplayModel extends BaseModel implements IProjektberichtDisplayModel {
  datumBis?: null | string;
  datumEingang?: null | string;
  datumFaelligkeit?: null | string;
  datumVon?: null | string;
  projectId?: string;
  projektberichtId?: string;
  status?: AceXFoundPortalCoreEntitiesAceProjektberichtAceProjektberichtEnumsAceProjektberichtStatuscode;
  typ?: AceXFoundPortalCoreEntitiesGlobalEnumsAceTypprojektbericht;
}
class BaseProjektberichtDisplayModelFormGroup extends FormGroup {
  private static _instance: ProjektberichtDisplayModelFormGroup;
  
  public static get Instance(): ProjektberichtDisplayModelFormGroup {
    this._instance = new ProjektberichtDisplayModelFormGroup({
      datumBis: new FormControl(null),
      datumEingang: new FormControl(null),
      datumFaelligkeit: new FormControl(null),
      datumVon: new FormControl(null),
      projectId: new FormControl(null),
      projektberichtId: new FormControl(null),
      status: new FormControl(null),
      typ: new FormControl(null),
    });

    return this._instance;
  }
}


export class ProjektberichtDisplayModelFormGroup extends BaseProjektberichtDisplayModelFormGroup {
  public get DatumBis(): FormControl {
    return this.controls["datumBis"] as FormControl;
  }
  public get DatumEingang(): FormControl {
    return this.controls["datumEingang"] as FormControl;
  }
  public get DatumFaelligkeit(): FormControl {
    return this.controls["datumFaelligkeit"] as FormControl;
  }
  public get DatumVon(): FormControl {
    return this.controls["datumVon"] as FormControl;
  }
  public get ProjectId(): FormControl {
    return this.controls["projectId"] as FormControl;
  }
  public get ProjektberichtId(): FormControl {
    return this.controls["projektberichtId"] as FormControl;
  }
  public get Status(): FormControl {
    return this.controls["status"] as FormControl;
  }
  public get Typ(): FormControl {
    return this.controls["typ"] as FormControl;
  }
  

}

export module ProjektberichtDisplayModelForm
  {
    export class FormFields
    {
      static _datumBis: string = "datumBis";
      static _datumEingang: string = "datumEingang";
      static _datumFaelligkeit: string = "datumFaelligkeit";
      static _datumVon: string = "datumVon";
      static _projectId: string = "projectId";
      static _projektberichtId: string = "projektberichtId";
      static _status: string = "status";
      static _typ: string = "typ";
    }
  }

